import React from 'react';
import './AboutComponent.css';
import '../../App.css'
import {Box, Button, Flex, Image, Link, Stack} from "@chakra-ui/react";

import appleLogo from '../../images/apple_store.png'
import googleLogo from '../../images/google_play_store.png'
import landingImage from '../../images/landing_screen.png'
import {useTranslation} from "react-i18next";

const AboutComponent = () => {
    const [t, i18n] = useTranslation('common');
    return (
        <Flex alignItems="center"
              className="header-component">
            <Flex flexDirection="column" className="about-component">
                <Flex flexDirection="column">
                    <Flex className="body-description">
                        <span>
                        {t("A swipe-based app")} <br/>{t("that matches")}
                            <span className="body-description-yellow"> {t("actors")} </span> <br/>{t("and")}
                            <span className="body-description-yellow"> {t("producers")} </span> {t("for")}<br/>
                        <span className="body-description-orange"> {t("independent projects")} </span>
                        </span>
                    </Flex>
                    <Box marginTop="24px;" textAlign="left">
                        <span
                            className="body-content">{t("Search for acting roles - or find actors for your own projects")} -<br/>{t("in short-films, commercials, music videos, and even feature films")}</span>
                    </Box>
                </Flex>
                <Flex flexDirection="column" className="about-component-actions">
                    <Stack direction="row"
                           spacing="12px"
                           textColor="black">
                        <Link >
                            <Button
                                leftIcon={<Image
                                    src={appleLogo}
                                    alt="new"
                                    height="20px"
                                    width="20px"
                                    objectFit="contain"/>}
                                fontSize="14px"
                                fontWeight="500"
                                minHeight="52px"
                                paddingRight="22px"
                                borderRadius="36px">
                                {t("App store").toUpperCase()}
                            </Button>
                        </Link>
                        <Link >
                            <Button
                                leftIcon={<Image
                                    src={googleLogo}
                                    alt="new"
                                    height="20px"
                                    width="20px"
                                    objectFit="contain"/>}
                                fontSize="14px"
                                fontWeight="500"
                                minHeight="52px"
                                paddingRight="22px"
                                borderRadius="36px">
                                {t("Google play").toUpperCase()}
                            </Button>
                        </Link>
                    </Stack>
                    <Box marginTop="12px">
                        <span className="body-content-extra-small-transparent">{t("Basic membership is free")}</span>
                    </Box>
                </Flex>
            </Flex>
            <Box width="80px"/>
            <Flex className="spacer" flexGrow={1}/>
            <Flex  className="producer-image-container header-image-container">
                <div className="spacer"/>
                <Image
                    className="producer-image"
                    maxWidth="300px"
                    paddingTop="0px"
                    src={landingImage}
                    alt="Indie app"
                    objectFit="contain"/>
                <div className="spacer"/>
            </Flex>
            <Flex className="spacer" flexGrow={1}/>
        </Flex>
    )

}
export default AboutComponent